export const SET_ACTIVE_CONSTRUCTION_TYPE = '[Component State] Set Active Construction Type';
export const SET_ACTIVE_CONSTRUCTION_LAYER = '[Component State] Set Active Construction Layer';
export const SET_COUNTRIES = '[Component State] Set Countries';
export const SET_SELECTED_COUNTRY = '[Component State] Set Selected Country';
export const SET_SELECTED_CULTURE = '[Component State] Set Selected Culture';
export const SET_GTM_CONTAINER = '[Component State] Set GTM Container';
export const SET_PROJECT_CONFIG = '[Component State] Set Project Config';
export const SET_COUNTIES = '[Component State] Set Counties';
export const SET_FIELD_DATA = '[Component State] Set FieldData';
